var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49609 10.0023C6.65229 10.0023 5.67829 9.91897 5.19709 10.7523C4.99609 11.1004 4.99609 11.5677 4.99609 12.5023V13.5023C4.99609 14.4369 4.99609 14.9042 5.19709 15.2523C5.67829 16.0857 6.65229 16.0023 7.49609 16.0023C8.33999 16.0023 9.31399 16.0857 9.79519 15.2523C9.99609 14.9042 9.99609 14.4369 9.99609 13.5023V12.5023C9.99609 11.5677 9.99609 11.1004 9.79519 10.7523C9.31399 9.91897 8.33999 10.0023 7.49609 10.0023Z",
    stroke: "#5A53DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.00232C15.6561 4.00232 14.6821 3.91895 14.201 4.75232C13.9999 5.10039 13.9999 5.5677 13.9999 6.50232V13.5023C13.9999 14.4369 13.9999 14.9042 14.201 15.2523C14.6821 16.0857 15.6561 16.0023 16.5 16.0023C17.3439 16.0023 18.3179 16.0857 18.799 15.2523C19 14.9042 19 14.4369 19 13.5023V6.50232C19 5.5677 19 5.10039 18.799 4.75232C18.3179 3.91895 17.3439 4.00232 16.5 4.00232Z",
    stroke: "#5A53DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20H22",
    stroke: "#5A53DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBuilding);
export default __webpack_public_path__ + "static/media/new-building.c4fbabe40a39af35fc9f51982bb22d87.svg";
export { ForwardRef as ReactComponent };